import styled from "styled-components";

import { formLabelStyles, formInputStyles } from "../../../constants/Styles";

const Container = styled.div<{ isDateField?: boolean; disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  > input,
  textarea {
    height: 100%;
  }

  ${formLabelStyles};

  ${formInputStyles};

  ${({ isDateField }) =>
    isDateField &&
    `
        // hiding default icon since it can't be styled
        > input::-webkit-calendar-picker-indicator {
            opacity: 0;
            position: absolute;
            bottom: 0;
            right: 0;
            width: 3.5rem;
            height: 2.5rem;
            cursor: pointer;
        }
        
        > input::before {
              content: "\\1F4C5"; // calendar icon
              position: absolute;
              top: 2.25rem;
              right: .75rem; 
              transform: translateY(-50%);
        }
    `}

  ${({ disabled }) =>
    disabled &&
    `
        filter: brightness(50%);
      `}
`;

export { Container, formLabelStyles };
